<template>
  <div>
    <div class="card-header">
      <button class="btn btn-outline-primary spacer" @click="getBasic">
        BHCPF
      </button>
      <button class="btn btn-outline-primary spacer" @click="getSEP">
        SEP
      </button>
    </div>
    <highcharts :options="chartOptions"></highcharts>

    <div class="col-md-12">
      <div class="text-center">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="40"
                        aria-controls="my-table"
                        @input="getDashboardLGA(currentPage ? currentPage : 1)"
                      ></b-pagination>
                    </div>

    </div>
    <p class="text-primary" v-show="isLoading">Chart Loading...</p>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        loader="dots"
        :can-cancel="true"
        :is-full-page="fullPage"
      ></loading>
    </div>
  </div>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: false,
      rows: "",
      title: "",
      sector: "Basic Healthcare Provision Fund",
      points: [10, 0, 8, 2, 6, 4, 5, 5],
      chartType: "",
      seriesColor: "#6fcd98",
      colorInputIsSupported: null,
      chartOptions: {},
    };
  },
  mounted() {
    this.getDashboardLGA();
  },
  methods: {
    getDashboardLGA(currentPage) {
      this.isLoading = true;
      this.axios
        .get("/api/v1/auth/EnrolleeDashboardProviderData/2679", {
          params: {
            page: currentPage,
            sector: this.sector,
          },
        })
        .then((response) => {
          var data = response.data;
          this.rows = response.data[0].lga.meta.total;
          this.isLoading = false;

          console.log(data[0].wards);
          this.chartOptions = {
            chart: {
              type: "column",
            },
            title: {
              text: `Enrollee Distribution Chart For ${this.sector}`,
            },
            subtitle: {
              text: "View enrollees breakdown based on facility.",
            },
            accessibility: {
              announceNewData: {
                enabled: true,
              },
            },
            xAxis: {
              type: "category",
            },
            yAxis: {
              title: {
                text: "NUMBER OF ENROLLEES",
              },
            },
            legend: {
              enabled: false,
            },
            plotOptions: {
              series: {
                borderWidth: 0,
                dataLabels: {
                  enabled: true,
                  // format: '{point.y:.1f}'
                },
              },
            },

            tooltip: {
              headerFormat:
                '<span style="font-size:11px">{series.name}</span><br>',
              pointFormat:
                '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>',
            },

            series: [data[0].lga],
             drilldown: {
              series: data[0].drilldown,
            },
          };
        });
    },

    getBasic() {
      this.sector = "Basic Healthcare Provision Fund";
      this.getDashboardLGA();
    },
    getSEP() {
      this.sector = "State Equity Program";
      this.getDashboardLGA();
    },
  },
};
</script>

<style></style>
